import { Button } from '@material-ui/core';
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { defineMessages, FormattedMessage } from 'react-intl';

import * as events from '../../../events';
import * as actions from '../../../state';
import styles from './styles.module.css';
import appleLogo from './apple-logo.png';

const messages = defineMessages({
  LOG_IN_WITH_APPLE: {
    id: 'LOG_IN_WITH_APPLE',
    defaultMessage: 'Log in with Apple',
  },
});

// function parseJwt(token) {
//   const base64Url = token.split('.')[1];
//   const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
//   const jsonPayload = decodeURIComponent(
//     atob(base64)
//       .split('')
//       .map((c) => `%${(`00${c.charCodeAt(0).toString(16)}`).slice(-2)}`)
//       .join(''),
//   );
//
//   return JSON.parse(jsonPayload);
// }

function AppleSso() {
  const dispatch = useDispatch();
  const appleSsoClientId = useSelector((state) => actions.selectConfig(state, 'PORTAL_LOGIN_APPLE_SSO_CLIENT_ID'));
  // eslint-disable-next-line max-len
  const appleSsoClientIdByHost = useSelector((state) => actions.selectConfig(state, `PORTAL_LOGIN_APPLE_SSO_CLIENT_ID_${window.location.hostname}`));

  const initApple = () => {
    const clientId = appleSsoClientIdByHost || appleSsoClientId;

    // eslint-disable-next-line no-undef
    AppleID.auth.init({
      clientId, // 'com.netsapiens.local',
      scope: 'name email',
      redirectURI: window.location.href,
      usePopup: true,
    });
  };

  useEffect(() => {
    const aScript = document.createElement('script');
    aScript.type = 'text/javascript';
    aScript.src = 'https://appleid.cdn-apple.com/appleauth/static/jsapi/appleid/1/en_US/appleid.auth.js';
    document.head.appendChild(aScript);

    aScript.onload = () => {
      initApple();
    };

    document.addEventListener('AppleIDSignInOnSuccess', (data) => {
      // const authCode = data.detail.authorization.code;
      const idToken = data.detail.authorization.id_token;
      // const parsedToken = this.parseJwt(idToken);
      // const { email } = parsedToken;

      // eslint-disable-next-line react/destructuring-assignment
      dispatch(events.ssoLoginUser(idToken, 'apple'));
    });

    document.addEventListener('AppleIDSignInOnFailure', (error) => {
      console.error('AppleIDSignInOnFailure', error);
    });
  }, []);

  // eslint-disable-next-line class-methods-use-this
  const ssoLogin = (e) => {
    e.preventDefault();
    document.getElementById('appleid-signin').click();
  };

  return (
    <div className={styles.ssoContainer}>
      <Button
        fullWidth
        size="large"
        type="submit"
        variant="contained"
        className={styles.ssoBtn}
        onClick={ssoLogin}
      >
        <img src={appleLogo} alt="logo" className={styles.ssoLogo} />
        <FormattedMessage {...messages.LOG_IN_WITH_APPLE} />
      </Button>
    </div>
  );
}

export default AppleSso;
